// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const materialInTitleMax = 200;

export const materialInUrlOneMax = 2000;

export const MaterialIn = zod.object({
  "audience": zod.enum(['internal', 'shareable']),
  "file_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "material_type": zod.enum(['one_pager', 'executive_deck', 'technical_deck', 'commercial_model', 'demo', 'case_study', 'architecture', 'other']),
  "revision": zod.int().min(1),
  "title": zod.string().min(1).max(materialInTitleMax),
  "url": zod.union([zod.string().max(materialInUrlOneMax),zod.null()]).optional()
});

export type MaterialIn = zod.input<typeof MaterialIn>;
export type MaterialInOutput = zod.output<typeof MaterialIn>;
